module.exports = __webpack_public_path__ + "static/meAvatar-be92eb9d7689aeb5ec62f3fc094b4610.jpg";